import { StarDoodle } from "@/components/doodles";

export const Marquee = ({ items, variant = "ink", rotate = "-rotate-1" }) => {
  const palette =
    variant === "ink"
      ? "bg-ink text-cream"
      : variant === "lime"
      ? "bg-lime text-ink"
      : "bg-pink text-cream";
  const starColor = variant === "ink" ? "text-pink" : variant === "lime" ? "text-ink" : "text-cream";

  return (
    <div
      className={`relative ${rotate} ${palette} border-y-[3px] border-ink py-3 sm:py-4 overflow-hidden marquee -mx-2`}
      data-testid="brand-marquee"
      aria-label="brand values"
    >
      <div className="marquee-track items-center" style={{ animationDuration: "32s" }}>
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-8 sm:gap-12 pr-8 sm:pr-12" aria-hidden={half === 1}>
            {items.map((item, i) => (
              <span key={i} className="flex items-center gap-8 sm:gap-12">
                <span className="font-display font-extrabold uppercase text-2xl sm:text-4xl tracking-tight whitespace-nowrap">
                  {item}
                </span>
                <StarDoodle className={`w-6 h-6 shrink-0 ${starColor}`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
